/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {dlsColor, dlsTypography} from '../../theme/theme';
import {BodyTypography} from '../../typography/BodyTypography';
import {getFormattedPlayerTime} from './VideoPlayerUtils';

export interface DurationProps {
  progress: number;
  duration: number;
}

const useStyles = makeStyles((theme) => ({
  bodyStyle : {
    ...dlsTypography('body3'),
    color : dlsColor('grey1')
  }
}));

/**
 * @Duration
 *
 * Defines the Duration Component. It is to show the played and total video duration of
 * asset.
 *
 * Figma link to refer Duration component:
 * https://www.figma.com/file/srjlHrDuM90sCoaOwpjaDU/02_DLS_Components?node-id=4060%3A43298
 *
 * ```typescript
 * import Duration from '@ion/dls/src/components/videoplayer/Duration';
 *
 *  //API To find the video duration
 *  function handleDuration(duration) {
 *   setDuration(duration);
 *  }
 *
 *   <Duration progress={progress}
 *     duration={duration} />
 *
 * ```
 */
const Duration = ({
  progress,
  duration
}: DurationProps) => {
  const classes = useStyles();
  return (
    <>
      <BodyTypography className={classes.bodyStyle}>
        {getFormattedPlayerTime(progress)} - {getFormattedPlayerTime(duration)}
      </BodyTypography>
    </>
  );
};

export default Duration;
